module.exports = __webpack_public_path__ + "img/lunchpack.3677c484.png";